export { default as getMentionIds } from './getMentionIds';
